module.exports = __webpack_public_path__ + "img/base_divers_bus.36fad090.svg";